import H from 'constants/httpMethod.const';
import { NO } from 'constants/no';
import { AUTH_API } from 'middleware/api';
import authenticatedEndpoint from 'utils/backend/authenticatedEndpoint.util';
import jsonEndpoint from 'utils/backend/jsonEndpoint.util';
import logger from 'utils/logger.util';
import actionType from 'utils/mw/actionType.util';

const ATAG = 'postPin';
const L = logger(ATAG);

export const { init: LIB_UI_POST_PIN_REQUEST, pass: LIB_UI_POST_PIN_SUCCESS, fail: LIB_UI_POST_PIN_FAILURE, done: LIB_UI_POST_PIN_FINISHED } = actionType('postPin');

const postPin = L.wrap('()', ({ salonId, pin }) => ({
  ATAG,
  [AUTH_API]: {
    ...authenticatedEndpoint({ pinSafe: true }),
    ...jsonEndpoint(H.post, `authentication/unlock/pin/${salonId || NO.id}/`, { pin: pin || null }),
    maxRetries: 0,
    params: { method: H.post, salonId, pin },
    types: [LIB_UI_POST_PIN_REQUEST, LIB_UI_POST_PIN_SUCCESS, LIB_UI_POST_PIN_FAILURE],
  },
}));

// noinspection JSUnusedGlobalSymbols
export default postPin;
